import { render, staticRenderFns } from "./hesuanmingxi.vue?vue&type=template&id=2d36ad88&scoped=true&"
import script from "./hesuanmingxi.vue?vue&type=script&lang=js&"
export * from "./hesuanmingxi.vue?vue&type=script&lang=js&"
import style0 from "./hesuanmingxi.vue?vue&type=style&index=0&id=2d36ad88&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d36ad88",
  null
  
)

export default component.exports